module.exports = __webpack_public_path__ + "static/media/gregory.2ffda0f4.jpg";